export default __webpack_public_path__ + "static/media/img_20.872beaa1.jpg";